exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1R1r30tOooTZgEI1gv8UYk{text-align:center}._1R1r30tOooTZgEI1gv8UYk ._1HosGHsqznhrYyWRbWDW6D{position:relative;overflow:hidden}._1R1r30tOooTZgEI1gv8UYk ._38s4gHAP3QrUZTXHgyhIc-{position:absolute;top:-15px;right:-15px;bottom:-15px;left:-15px;filter:blur(10px);z-index:0}._1R1r30tOooTZgEI1gv8UYk ._13vpvoOz9w39CL9zwCwIO0{display:block;margin:15px auto;position:relative;z-index:1;border:2px solid #fff}._1R1r30tOooTZgEI1gv8UYk ._2q_bemB2FvZup3zb-e1HA-{padding:20px 20px}._1R1r30tOooTZgEI1gv8UYk ._1NmAZ4i62iQLHLhkdUu52y{margin-bottom:5px}._1R1r30tOooTZgEI1gv8UYk ._3owwUQocgBzbIV70eMHoUy{color:#757575}._1R1r30tOooTZgEI1gv8UYk ._2KP9v-bwhxUtJMzxEorE7n{margin-top:10px}._1R1r30tOooTZgEI1gv8UYk ._3gM8eVkutQHk6t6NY1R1P0{display:inline-block;margin-top:30px}\n", ""]);

// Exports
exports.locals = {
	"ProfileCard": "_1R1r30tOooTZgEI1gv8UYk",
	"top": "_1HosGHsqznhrYyWRbWDW6D",
	"topBgImg": "_38s4gHAP3QrUZTXHgyhIc-",
	"profileImg": "_13vpvoOz9w39CL9zwCwIO0",
	"bottom": "_2q_bemB2FvZup3zb-e1HA-",
	"userName": "_1NmAZ4i62iQLHLhkdUu52y",
	"userLoc": "_3owwUQocgBzbIV70eMHoUy",
	"userDesc": "_2KP9v-bwhxUtJMzxEorE7n",
	"manageAccount": "_3gM8eVkutQHk6t6NY1R1P0"
};